<template>
  <div class="relative">
    <el-tabs :class="custom" v-model="activeTab">
      <el-tab-pane
        :label="tab.name"
        :name="tab.name"
        v-for="(tab, i) in tabs"
        :key="i"
      >
        <template #label
          ><tippy
            :arrow="false"
            :content="`${tab.name} (${
              state.platformPerTab[
                tab.name === 'Off-Chain' ? 'offChain' : 'onChain'
              ]
            })`"
          >
            <PlatformSelect @platform-change="handlePlatformChange" :tab="tab"
          /></tippy>
        </template>
      </el-tab-pane>
    </el-tabs>
    <span
      v-if="lastActiveTime"
      class="absolute top-0 right-0 text-sm text-white-040"
      >Last active {{ formatDateText(lastActiveTime * 1000) }}</span
    >
  </div>
</template>
<script setup>
import { inject, onMounted, reactive, ref, watch, computed } from 'vue';
import PlatformSelect from './PlatformSelect.vue';
const emits = defineEmits(['platformChange', 'tabChange']);
import { formatDateText } from '@/utils';
const props = defineProps({
  tabs: Array,
  updateTime: Number,
  custom: String,
  selectedTab: String,
  lastActiveTime: Number,
});
const activeTab = ref(null);
const state = reactive({
  selectedTab: null,
  selectedPlatformIndex: 0,
  menu: [0, 0],
  platformPerTab: { offChain: null, onChain: null },
});
const dropdown1 = ref();
watch(
  () => props.tabs,
  () => {
    if (props.tabs) activeTab.value = props.tabs[0]?.name;
    if (props.selectedTab) activeTab.value = props.selectedTab;
  },
);
watch(
  () => props.selectedTab,
  () => {
    if (props.selectedTab) activeTab.value = props.selectedTab;
  },
);
function showClick() {
  if (!dropdown1.value) return;

  dropdown1.value.handleOpen();
}
// const handleTabChange = (a) => {
//   console.log(activeTab.value);
// };
const handlePlatformChange = (tabName, platform) => {
  if (tabName === 'Off-Chain') state.platformPerTab.offChain = platform;
  else state.platformPerTab.onChain = platform;
  emits('platformChange', activeTab.value, tabName, platform);
};

onMounted(() => {
  watch(
    () => activeTab.value,
    () => {
      if (activeTab.value === 'Off-Chain')
        emits('tabChange', activeTab.value, state.platformPerTab.offChain);
      else emits('tabChange', activeTab.value, state.platformPerTab.onChain);
    },
  );
  if (props.tabs) activeTab.value = props.tabs[0]?.name;
});
</script>
<style></style>
